import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { influencer } from "../../helpers/Influencer";
import { useEffect, useRef, useState } from "react";
import { addToRefsGeneric } from "../../utils/funtions";
import gsap from "gsap";
import { HeaderContributor } from "../../components/Contributors/HeaderContributor";
import { ModalContributor } from "../../components/Contributors/ModalContributor";
import { useLocation, useNavigate } from "react-router-dom";

export const Influencers = () => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);
  const [getId, setGetId] = useState<number>();
  const selectedData = influencer.filter((i) => i.id === getId);
  const cardRef = useRef<HTMLDivElement[]>([]);
  const addCardRef = addToRefsGeneric(cardRef);

  const location = useLocation();
  const navigate = useNavigate();

  const onOpenModal = (id: number) => {
    setShowModal(true);
    setGetId(id);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardRef.current.forEach((el, i) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 95%",
            once: true,
          },
        });

        tl.fromTo(
          el,
          {
            opacity: 0,
            y: 80,
            rotateX: 10,
            scale: 0.95,
            filter: "blur(8px)",
            transformPerspective: 800,
          },
          {
            opacity: 1,
            y: 0,
            rotateX: 0,
            scale: 1,
            filter: "blur(0px)",
            duration: 1.2,
            ease: "expo.out",
          }
        );
      });
    });

    return () => ctx.revert();
  }, []);

  const onNavigateInfluencers = () => {
    navigate("/influencers");
  };

  const onNavigateAmbassador = () => {
    navigate("/ambassadors");
  };

  return (
    <Box>
      <HeaderContributor
        title="Nikolay"
        subtitle="Influencers"
        fontSizeMd={30}
        fontSizeXs={18}
        description="The third level of our Ambassador program. Chosen by the 
        retailer and approved by our team, the Nikolay Influencers are ambassadors 
        both for the shop and brand. They are receiving products and promote them an
        the shop that chose them. Each retailer has its own terms of applying to the 
        program, and you should contact the shop to know the details."
      />
      <Grid
        mt={15}
        mb={50}
        container
        display="flex"
        justifyContent="center"
        spacing={{ xs: 2, md: 3 }}
        marginInline={{ xs: 2, md: 5 }}
      >
        <Grid
          display="flex"
          mb={1}
          justifyContent={{ xs: "center", md: "flex-end" }}
          size={12}
        >
          <Box
            display="flex"
            gap={1}
            padding={1}
            borderRadius={2}
            bgcolor={theme.palette.customColor?.main}
          >
            <Button
              onClick={onNavigateInfluencers}
              disableElevation
              variant="contained"
              sx={{
                  color:
                  location.pathname !== "/influencers"
                    ? theme.palette.secondary[100]
                    : theme.palette.secondary.main,
                backgroundColor:
                  location.pathname === "/influencers"
                    ? theme.palette.customColor?.dark
                    : theme.palette.customColor?.main,
              }}
            >
              Influencers
            </Button>

            <Button
              disableElevation
              variant="contained"
              onClick={onNavigateAmbassador}
              sx={{
                color:
                  location.pathname !== "/ambassadors"
                    ? theme.palette.secondary[100]
                    : theme.palette.secondary.main,
                backgroundColor:
                  location.pathname === "/ambassadors"
                    ? theme.palette.customColor?.dark
                    : theme.palette.customColor?.main,
              }}
            >
              Ambassadors
            </Button>
          </Box>
        </Grid>
        {influencer.map((a) => (
          <Grid
            ref={addCardRef}
            size={{ xs: 6, sm: 4, md: 2 }}
            key={a.id}
            height={{ xs: 300, md: 350 }}
          >
            <Card
              elevation={1}
              sx={{
                borderRadius: 3,
                position: "relative",
                overflow: "hidden",
                width: "100%",
                height: "100%",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.02)"}
              }}
            >
              <CardActionArea

                sx={{ width: "100%", height: "100%" }}
                onClick={() => onOpenModal(a.id)}
              >
                <CardMedia
                  component="img"
                  src={a.image}
                  loading="lazy"
                  width="100%"
                  height="100%"
                  sx={{transition: "transform 0.3s ease", "&:hover ": {transform: "scale(1.1)" } }}
                />
                <Box
                  position="absolute"
                  zIndex={99}
                  bottom={10}
                  left={10}
                  color={theme.palette.common.white}
                >
                  <Typography
                    fontWeight={700}
                    variant="body1"
                    textTransform="uppercase"
                  >
                    {a.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    color={theme.palette.background.paper}
                  >
                    {a.category}
                  </Typography>
                </Box>
              </CardActionArea>

              <Box
                width="100%"
                boxShadow="0px 0px 80px 50px black"
                position="absolute"
                bottom={0}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
      <ModalContributor
        data={selectedData}
        open={showModal}
        onClose={onCloseModal}
      />
    </Box>
  );
};
